// 当前前端构建版本号（时间戳，由 webpack DefinePlugin 注入）
export const BUILD_VERSION = typeof __BUILD_VERSION__ !== 'undefined' ? __BUILD_VERSION__ : '0'

/**
 * 检查前端版本是否为最新
 * fetch 构建时生成的 version.json，与本地 __BUILD_VERSION__ 比对
 * 当本地版本 < 服务器版本时，触发浏览器强制刷新
 */
export function checkVersion() {
  // 开发环境不检查
  if (process.env.NODE_ENV === 'development') {
    return
  }

  fetch(`./version.json?_t=${Date.now()}`)
    .then(res => res.json())
    .then(data => {
      const serverVersion = data && data.version
      if (!serverVersion) return
      if (Number(BUILD_VERSION) < Number(serverVersion)) {
        console.warn(`[版本检查] 当前版本 ${BUILD_VERSION} < 服务器版本 ${serverVersion}，即将刷新页面`)
        // 清除缓存并强制刷新
        if (window.caches) {
          window.caches.keys().then(names => {
            names.forEach(name => window.caches.delete(name))
          })
        }
        window.location.reload(true)
      }
    })
    .catch(() => {
      // 版本检查失败不影响正常使用
    })
}
